import { RentalInformationForm } from "./RentalInformationForm";
import { validateRentalInformationForm } from "./validateRentalInformationForm";

RentalInformationForm.validate = validateRentalInformationForm;

export { RentalInformationForm };
